/* eslint-disable */
// TODO: conver to functional component
import React from "react";
import PropTypes from "prop-types";
import ImmutablePropTypes from 'react-immutable-proptypes';
import { connect } from "react-redux";

import Component from "components/component";

import Currency from "./currency";
import mapDispatchToProps from "lib/map-dispatch-to-props";
import * as modalActions from "actions/modals";
import { calculateEstimatedTotal } from 'selectors/configurator-selectors';

class SummaryMobile extends Component {
  static propTypes = {
    estimatedTotalPrice: PropTypes.number,
    product: ImmutablePropTypes.map,
    userId: PropTypes.string,
    userRole: PropTypes.string
  };

  openLogin = e => {
    e.preventDefault();

    const { tradeAccessPending } = this.props;

    if (tradeAccessPending) {
      this.props.actions.modalActions.openModal("trade-access-pending");
    } else {
      this.props.actions.modalActions.openModal("login");
    }
  };

  isCustom = () => {
    return this.props.sectionalLayoutIsCustom || this.props.sideADimension || this.props.sideBDimension || this.props.sideCDimension;
  }

  render() {
    const {
      estimatedTotalPrice,
      product,
      userId,
      userRole,
      selections,
      selectedVariant,
    } = this.props;

    let listPrice = selectedVariant.get('listPrice');
    let totalListPrice = calculateEstimatedTotal(listPrice, selections);
    const isCustom = this.isCustom();

    return (
      <div className="configurator-summary mobile-only">
        <div className="product-quote-price">
          <table>
            <tbody>
              <tr>
                <td>
                  <p className="product-name">{product.get("name")}</p>
                </td>

                {isCustom ? (
                  <td><p className="price-text">Request Price</p></td>
                ) : (
                  <td>
                    { (userId && userRole === 'trade_user') ? (
                      <>
                        <p className="price-text">
                          Net Price
                          <span className="price">
                            <Currency price={estimatedTotalPrice} />
                          </span>
                        </p>
                      </>
                      ) : (
                        <p className="price-text">
                          <a
                            onClick={this.openLogin}
                            className="large right signup-button"
                          >
                            View Net Pricing
                          </a>
                        </p>
                      )
                    }
                    <p className="price-text">
                      <small>Est. Price</small>
                      <br />
                      <span className="price">
                        <Currency price={userId && userRole === 'trade_user' ? estimatedTotalPrice : totalListPrice} />
                      </span>
                    </p>
                  </td>
                )}
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { userId, userRole, tradeAccessPending } = state.userStore.toObject();
  return {
    userId,
    userRole,
    tradeAccessPending,
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps(modalActions)
)(SummaryMobile);
